import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "recipientsSelection",
    "groupsMultiselect",
    "recipientsMultiselect",
  ]

  connect() {
    this.toggleSelect()
  }

  toggleSelect() {
    const value = this.recipientsSelectionTarget.value

    switch (value) {
      case "selected_groups":
        this.showGroups()
        break

      case "selected_recipients":
        this.showRecipients()
        break

      default:
        this.hideAll()
        break
    }
  }

  showGroups() {
    this.groupsMultiselectTarget.classList.remove("hidden")
    this.recipientsMultiselectTarget.classList.add("hidden")
  }

  showRecipients() {
    this.recipientsMultiselectTarget.classList.remove("hidden")
    this.groupsMultiselectTarget.classList.add("hidden")
  }

  hideAll() {
    this.groupsMultiselectTarget.classList.add("hidden")
    this.recipientsMultiselectTarget.classList.add("hidden")
  }
}
